import {InjectionToken} from "@angular/core";
import {DAYS_IN_WEEK} from "../constants";

export const INT_DAYS_IN_WEEK_TOKEN = new InjectionToken<number>('INT_DAYS_IN_WEEK_TOKEN', {
  factory() {
    return DAYS_IN_WEEK;
  }
})
